import UsersTable from '@/components/common/tables/users-table/UsersTable';

const Users = () => {
  return (
    <div className="w-full">
      <UsersTable />
      {/* ClientsKPIs component */}
      {/* Tabs */}
      {/* <ClientsTable /> <-- This is the table that displays the clients in TabContent */}
      {/* <ParticipantsTable /> <-- This is the table that displays the participants in TabContent (disabled, for next sprint) */}
    </div>
  );
};

export default Users;
